module.exports = __webpack_public_path__ + "static/opc4-b44bfbeed08e737dca50cb282b41d8c2.png";